module.exports = __webpack_public_path__ + "static/media/autoline.b5db7a8b.png";